import { SavedReportDashboard } from '../common/types-store';

export const ACTION = {
  REQUEST_SAVED_REPORTS: 'DASHBOARD_SAVED_REPORTS:REQUEST_SAVED_REPORTS',
  RECEIVE_SAVED_REPORTS: 'DASHBOARD_SAVED_REPORTS:RECEIVE_SAVED_REPORTS',
  FAIL_SAVED_REPORTS: 'DASHBOARD_SAVED_REPORTS:FAIL_SAVED_REPORTS',

  REQUEST_SAVE_SAVED_REPORTS: 'DASHBOARD_SAVED_REPORTS:REQUEST_SAVE_SAVED_REPORTS',
  RECEIVE_SAVE_SAVED_REPORTS: 'DASHBOARD_SAVED_REPORTS:RECEIVE_SAVE_SAVED_REPORTS',
  FAIL_SAVE_SAVED_REPORTS: 'DASHBOARD_SAVED_REPORTS:FAIL_SAVE_SAVED_REPORTS',

  CLEAR_SAVED_REPORTS: 'DASHBOARD_SAVED_REPORTS:CLEAR_SAVED_REPORTS'
};

export class RequestSavedReports {
  public type: string = ACTION.REQUEST_SAVED_REPORTS;
  constructor(public dashboardTypeId: number) { }
}

export class ReceiveSavedReports {
  public type: string = ACTION.RECEIVE_SAVED_REPORTS;
  constructor(
    public dashboardTypeId: number,
    public accessType: number,
    public description: string,
    public savedReports: SavedReportDashboard[]
  ) { }
}

export class FailSavedReports {
  public type: string = ACTION.FAIL_SAVED_REPORTS;
  constructor(public dashboardTypeId: number) { }
}

export class RequestSaveSavedReports {
  public type: string = ACTION.REQUEST_SAVE_SAVED_REPORTS;
  constructor(public dashboardTypeId: number) { }
}

export class ReceiveSaveSavedReports {
  public type: string = ACTION.RECEIVE_SAVE_SAVED_REPORTS;
  constructor(public dashboardTypeId: number) { }
}

export class FailSaveSavedReports {
  public type: string = ACTION.FAIL_SAVE_SAVED_REPORTS;
  constructor(public dashboardTypeId: number) { }
}

export class ClearSavedReports {
  public type: string = ACTION.CLEAR_SAVED_REPORTS;
}
